// Helpers for bridging an absolute UTC ISO instant (what we store in filter
// state and the URL, so a shared link resolves to the same range in any
// timezone) and the local wall-clock value an `<input type="datetime-local">`
// works with.

/**
 * Convert a `datetime-local` input value (local wall-clock, no timezone) to an
 * absolute UTC ISO instant. Returns null for empty or unparseable input.
 */
export function localInputToIso(value: string): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (isNaN(date.getTime())) return null;
  return date.toISOString();
}

/**
 * Convert an absolute ISO instant to the `YYYY-MM-DDTHH:mm` local wall-clock
 * string a `datetime-local` input expects. Returns '' for empty/unparseable input.
 */
export function isoToLocalInput(iso: string): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
